
  <ng-container>
    <div mat-dialog-title>
      <h2>{{"profile.Set Place Order Time" | translate}}</h2>
      <button mat-icon-button class="close" (click)="openConfirmDialog()">
        <mat-icon class="pop-close">close</mat-icon>
      </button>
    </div>
    <form [formGroup]="formGroup">
      <mat-dialog-content class="pt-0 pb-0">
        <div class="mat-dialog-body">
          <div class="fields-group">
            <mat-form-field class="mb-2" hideRequiredMarker>
              <mat-label>{{"profile.Number of Hours" | translate}}</mat-label>
              <input matInput formControlName="placeOrderTime" appOnlynumber maxlength="1" [min]="1" [max]="7">
              <mat-error *ngIf="hasError('placeOrderTime', 'required')">{{ 'forms.Required' | translate }}</mat-error>
              <mat-error *ngIf="hasError('placeOrderTime', 'max') || hasError('placeOrderTime', 'min')">{{ 'forms.Invalid' | translate }} (1-6)</mat-error>
            </mat-form-field>
          </div>
        </div>
      </mat-dialog-content>
      <mat-dialog-actions>
        <button mat-button class="btn-grey" (click)="openConfirmDialog()">{{"forms.Cancel" | translate}}</button>
        <button (click)="saveRecord()" mat-raised-button color="primary" [disabled]="loading" [class.loading]="loading">
          {{"forms.Save" | translate}}
        </button>
      </mat-dialog-actions>
    </form>
  </ng-container>
